export default (value, decimals = 4) =>
  Number(Math.round(`${value}e${decimals}`) + `e-${decimals}`);
